import React, { useState, useEffect } from 'react';
import './Causes.css';

const contentData = [
  {
    title: "Bacterial Invasion",
    text: "Bacteria are the primary culprits behind mastitis- Staphylococcus, Streptococcus and E. coli. These pathogens enter the udder through the teat canal, often during or after milking. Without proper hygiene, they can multiply rapidly and trigger infection.",
    img: "/images/cause1.jpg"
  },
  {
    title: "Poor Milking Hygiene",
    text: "Using dirty hands, reusable cloths, or unsanitized milking machines creates ideal conditions for bacterial spread. Inconsistent pre- and post-milking teat disinfection also allows pathogens to pass from cow to cow — increasing herd-wide infection risk.",
    img: "/images/cause2.jpg"
  },
  {
    title: "Teat and Udder Injuries",
    text: "Cracks, cuts, or bruises on the udder or teat open the door for bacterial entry. Rough handling, over-milking, or ill-fitted machines can damage the teat, weakening the cow’s natural defenses and accelerating infection.",
    img: "/images/cause3.jpg"
  },
  {
    title: "Unsanitary Housing/Farm Conditions",
    text: "Moist, dirty bedding and manure buildup provide a breeding ground for mastitis-causing bacteria. When cows lie down, their udders come into direct contact with these surfaces — raising the risk of infection even before milking starts.",
    img: "/images/cause4.jpg"
  },
  {
    title: "Weakened Immune Response",
    text: "Stress, poor nutrition, or concurrent illnesses can suppress a cow’s immune system. When natural defenses are low, even minor bacterial exposure can lead to full-blown mastitis. Young and old animals are especially vulnerable.",
    img: "/images/cause5.jpg"
  }
];

const Causes = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
   useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % contentData.length);
    }, 3000);

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  const handleSelect = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section id="causes" className="causes-section" data-aos="fade-up">
      <div className="causes-container">
        <div className="text-side">
          <h2>{contentData[currentIndex].title}</h2>
          <p>{contentData[currentIndex].text}</p>
        </div>
        <div className="image-side">
          <img src={contentData[currentIndex].img} alt="Cause" />
        </div>
      </div>

      <div className="dot-navigation">
        {contentData.map((_, idx) => (
          <button
            key={idx}
            className={`dot ${currentIndex === idx ? 'active' : ''}`}
            onClick={() => handleSelect(idx)}
          />
        ))}
      </div>
    </section>
  );
};

export default Causes;
